import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Button } from 'react-bootstrap';
import ReactTable from 'react-table';

import WellEditModalEnhanced from './WellEditModalEnhanced';
import WellMergeModal from './WellMergeModal';
import { defaultTableFiltering } from '../../../../utils';
import LookupStatusIcon from '../../../lookups/components/LookupStatusIcon';


const propTypes = exact({
  wellList: PropTypes.array.isRequired,
  selectedWell: PropTypes.object,

  showWellEntryModal: PropTypes.bool.isRequired,
  openWellEditModal: PropTypes.func.isRequired,
  closeWellEditModal: PropTypes.func.isRequired,

  showWellMergeModal: PropTypes.bool.isRequired,
  openWellMergeModal: PropTypes.func.isRequired,
  closeWellMergeModal: PropTypes.func.isRequired,

  enableLookupFeature: PropTypes.bool.isRequired,
});


const WellTable = (props) => {
  const { wellList, selectedWell } = props;
  const { showWellEntryModal, openWellEditModal, closeWellEditModal } = props;
  const { showWellMergeModal, openWellMergeModal, closeWellMergeModal } = props;
  const { enableLookupFeature } = props;

  const well = (selectedWell) ? selectedWell.well : null;
  const leaseId = (well) ? well.lease.id : null;

  return (
    <React.Fragment>
      <ReactTable
        data={wellList}
        filterable
        defaultFilterMethod={(filter, row) => {
          return defaultTableFiltering(filter, row);
        }}
        columns={[
          {
            Header: 'Status',
            id: 'lookup_status',
            filterable: false,
            accessor: (row) => {
              return row.lookupStatus;
            },
            show: enableLookupFeature,
            Cell: (row) => {
              return <LookupStatusIcon lookupStatus={row.original.lookupStatus} />;
            },
          },
          {
            Header: 'Well Name',
            id: 'well_name',
            accessor: (e) => { return e.name; },
          },
          {
            Header: 'Lease Name',
            id: 'lease_name',
            accessor: (e) => { return e.well.lease.name; },
          },
          {
            Header: 'Operator Name',
            id: 'operator_name',
            accessor: (e) => { return e.well.lease.operator.name; },
          },
          {
            Header: 'Actions',
            id: 'actions',
            filterable: false,
            sortable: false,
            Cell: (row) => {
              return (
                <React.Fragment>
                  <Button
                    bsStyle="info"
                    onClick={() => { openWellEditModal(row.original); }}
                  >
                    Edit
                  </Button>
                  {' '}
                  <Button
                    bsStyle="danger"
                    onClick={() => { openWellMergeModal(row.original); }}
                  >
                    Merge
                  </Button>
                </React.Fragment>
              );
            },
          },
        ]}
        defaultPageSize={10}
        className="-striped -highlight"
      />
      <WellEditModalEnhanced
        initialValues={well}
        leaseId={leaseId}
        show={showWellEntryModal}
        onHide={closeWellEditModal}
        joinType="lookup_records"
        lookupStatus="reference"
      />

      <WellMergeModal
        wellLookup={selectedWell}
        show={showWellMergeModal}
        onHide={closeWellMergeModal}
        onSubmit={closeWellMergeModal}
      />

    </React.Fragment>
  );
};

WellTable.propTypes = propTypes;


export default WellTable;
